const props = {
  readonly: {
    type: Boolean,
    default: false
  },
  disabled: {
    type: Boolean,
    default: false
  },
  editable: {
    type: Boolean,
    default: false
  },
  clearable: {
    type: Boolean,
    default: true
  },
  // isDouble: {
  //   type: Boolean,
  //   default: false
  // },
  size: String,
  pickerOptionsStart: Object,
  pickerOptionsEnd: Object,
  startPlaceholder: String,
  endPlaceholder: String,
  rangeSeparator: {
    type: String,
    default: '至'
  }
}

export default props



// WEBPACK FOOTER //
// ./src/components/tDateProps.js